<template>
  <div class="app-container">
    <div class="activity-list-filter">
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="区域" v-model="filter.regionName" size="medium" :disabled="filterDisable.regionName" clearable>
               <el-option
                v-for="item in regionOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
         <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="市场" v-model="filter.marketId" size="medium" :disabled="filterDisable.marketId" clearable>
               <el-option
                v-for="item in marketOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="总经理" v-model="filter.gmEid" size="medium" :disabled="filterDisable.gmEid" clearable>
               <el-option
                v-for="item in gmOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运总监" v-model="filter.doEid" :disabled="filterDisable.doEid" size="medium" clearable>
               <el-option
                v-for="item in doOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运经理" v-model="filter.omEid" :disabled="filterDisable.omEid" size="medium" clearable>
               <el-option
                v-for="item in omOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="营运顾问" v-model="filter.ocEid" :disabled="filterDisable.ocEid" size="medium" clearable>
               <el-option
                v-for="item in ocOptions"
                :key="item.eid"
                :label="item.name"
                :value="item.eid">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-input class="activity-list-filter-value" placeholder="餐厅国际编号" v-model.trim="filter.storeCode" :disabled="filterDisable.storeCode" @keyup.enter.native="loadData(true)" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input class="activity-list-filter-value" placeholder="餐厅名称" v-model.trim="filter.storeName" :disabled="filterDisable.storeName" @keyup.enter.native="loadData(true)" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input class="activity-list-filter-value" placeholder="员工编号" v-model.trim="filter.unionId" @keyup.enter.native="loadData(true)" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-input class="activity-list-filter-value" placeholder="员工姓名" v-model.trim="filter.nickname" @keyup.enter.native="loadData(true)" size="medium" />
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="身份" v-model="filter.identity" size="medium" clearable>
               <el-option
                v-for="item in identityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="职级" v-model="filter.grade" size="medium" clearable>
               <el-option
                v-for="item in gradeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="岗位海报" v-model="filter.hasPoster" size="medium" clearable>
               <el-option
                v-for="item in postOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="领取阳光" v-model="filter.hasGotPlanting" size="medium" clearable>
               <el-option
                v-for="item in sunshineOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="播撒阳光" v-model="filter.hasUsedPlanting" size="medium" clearable>
               <el-option
                v-for="item in sunshineStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="报名状态" v-model="filter.hasSignedUp" size="medium" clearable>
               <el-option
                v-for="item in signUpOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
         <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="食品安全认证" v-model="filter.foodSafetyFlag" size="medium" clearable>
               <el-option
                v-for="item in foodSafetyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-select class="activity-list-filter-value" placeholder="3个岗位鉴定" v-model="filter.positionAppraisalFlag" size="medium" clearable>
               <el-option
                v-for="item in positionAppraisalOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button class="activity-list-filter-search" size="medium" @click="loadData(true)">立即筛选</el-button>
          <el-button class="activity-list-filter-reset" size="medium" @click="clearFilter([])">清除条件</el-button>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud
        :page="pageItem"
        :data="data"
        @current-change="pageItem.currentPage=$event;loadData()"
        @size-change="pageItem.pageSize=$event;loadData(true)"
        @refresh-change="handleRefreshChange"
        :option="activityListOption"
        :table-loading="loading">

        <template slot="menuLeft">
          <el-button class="filter-item"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>
          <el-button class="filter-item"
            @click="handleSignUpExport()"
            size="small"
            type="primary"
            :loading="exportSignUpLoading"
            icon="el-icon-download">{{exportSignUpName}}
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>

import { activityListOption, options, signUpOptions, foodSafetyOptions, positionAppraisalOptions, identityOptions, postOptions, sunshineOptions, sunshineStatusOptions, gradeOptions } from '@/const/crud/activity/activity';
import { fetchList, fetchActivityFilterOptions, exportEmployeeActivityData, exportMemberSignUpData, fetchActivityFilter } from '@/api/activity/activity';
import { exporting } from '@/util/exportUtil'

export default {
  data() {
    return {
      data: [],
      pageItem: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      loading: false,
      activityListOption,
      filter: {
        regionName: '',
        marketId: '',
        gmEid: '',
        doEid: '',
        omEid: '',
        ocEid: '',
        unionId: '',
        nickname: '',
        storeCode: '',
        storeName: '',
        identity: '',
        hasPoster: '',
        hasGotPlanting: '',
        hasUsedPlanting: '',
        hasSignedUp: '',
        foodSafetyFlag: '',
        positionAppraisalFlag: '',
        grade: '',
      },
      marketOptions: [],
      regionOptions: [],
      gmOptions: [],
      doOptions: [],
      omOptions: [],
      ocOptions: [],
      filterOption: {},
      filterDisable: {},
      notClearOptions: false,
      currentOption: {},
      options: options,
      signUpOptions: signUpOptions,
      foodSafetyOptions: foodSafetyOptions,
      positionAppraisalOptions: positionAppraisalOptions,
      identityOptions: identityOptions,
      postOptions: postOptions,
      sunshineOptions: sunshineOptions,
      sunshineStatusOptions: sunshineStatusOptions,
      gradeOptions,
      exportName: '导出全表',
      exportSignUpName: '导出岗位报名',
      exportLoading: false,
      exportSignUpLoading: false,
    }
  },
  watch: {
    'filter.regionName': {
      handler(val) {
        if (!this.notClearOptions) {
          const excludedClearOptions = ['regionName', 'identity', 'hasPoster', 'hasGotPlanting', 'hasUsedPlanting', 'hasSignedUp', 'foodSafetyFlag', 'positionAppraisalFlag', 'grade'];
          this.clearOptions(excludedClearOptions);
        }
        this.marketOptions = this.filterOption.markets.filter(x => x.parentId === val);
      }
    },
    'filter.marketId': {
      handler(val) {
        if (!this.notClearOptions) {
          const excludedClearOptions = ['regionName', 'marketId', 'identity', 'hasPoster', 'hasGotPlanting', 'hasUsedPlanting', 'hasSignedUp', 'foodSafetyFlag', 'positionAppraisalFlag', 'grade'];
          this.clearOptions(excludedClearOptions);
        }
        this.gmOptions = this.filterOption.gms.filter(x => x.parentId === val);
      }
    },
    'filter.gmEid': {
      handler(val, oldVal) {
        if (val) {
          this.doOptions = this.filterOption.dos.filter(x => x.parentId === val);
        } else {
          this.doOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.doEid = '';
        }
      }
    },
    'filter.doEid': {
      handler(val, oldVal) {
        if (val) {
          this.omOptions = this.filterOption.oms.filter(x => x.parentId === val);
        } else {
          this.omOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.omEid = '';
        }
      }
    },
    'filter.omEid': {
      handler(val, oldVal) {
        if (val) {
          this.ocOptions = this.filterOption.ocs.filter(x => x.parentId === val);;
        } else {
          this.ocOptions = [];
        }
        if ((val && oldVal && val !== oldVal) || !val) {
          this.filter.ocEid = '';
        }
      }
    },
  },
  async created() {
    await this.loadFilterOptions();
    await this.loadData(true);
  },
  methods: {
    async loadData(init) {
      this.loading = true;
      this.pageItem.currentPage = init ? 1 : this.pageItem.currentPage;
      const page = {
        current: this.pageItem.currentPage,
        size: this.pageItem.pageSize,
      };
      const filter = Object.assign(JSON.parse(JSON.stringify(this.filter)), page);
      fetchList(filter).then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.data = this.formatData(response.data.data.records);
          this.pageItem.total = response.data.data.total;
          this.loading = false;
        }
      });
    },
    formatData(data) {
      if (data && data.length > 0) {
        data.forEach((item) => {
          if (!item.positionAppraisalFlag) {
            item.positionAppraisalFlag = 'N';
          }
          if (!item.foodSafetyFlag) {
            item.foodSafetyFlag = 'N';
          }
          if (!item.storeCode) {
            item.storeCode = '--';
          }
          if (!item.serviceStartDate) {
            item.serviceStartDate = '--';
          }

          const length = item.positionSignUpMembers ? item.positionSignUpMembers.length : 0;
          item.signedUpPosition1 = length >= 1 ? item.positionSignUpMembers[0].positionName : '--';
          item.signedUpPartner1 = length >= 1 ? item.positionSignUpMembers[0].partnerName : '--';
          item.signedUpPartner1 = item.signedUpPartner1 == null || item.signedUpPartner1 == undefined ? '--' : item.signedUpPartner1;
          item.signedUpPosition2 = length >= 2 ? item.positionSignUpMembers[1].positionName : '--';
          item.signedUpPartner2 = length >= 2 ? item.positionSignUpMembers[1].partnerName : '--';
          item.signedUpPartner2 = item.signedUpPartner2 == null || item.signedUpPartner2 == undefined ? '--' : item.signedUpPartner2;
          item.signedUpPosition3 = length >= 3 ? item.positionSignUpMembers[2].positionName : '--';
          item.signedUpPartner3 = length >= 3 ? item.positionSignUpMembers[2].partnerName : '--';
          item.signedUpPartner3 = item.signedUpPartner3 == null || item.signedUpPartner3 == undefined ? '--' : item.signedUpPartner3;
        });
      }
      return data;
    },
    async loadFilterOptions() {
      await fetchActivityFilterOptions().then(response => {
        if (response.data && response.data.code === 0) {
          this.filterOption = response.data.data;
          this.regionOptions = this.filterOption.regions;
        }
      });
      await fetchActivityFilter().then(res => {
        const result = res.data.data;
        if(!result) {
          return;
        }
        if (result.roleType === 'OC_OM_DO') {
          this.notClearOptions = true;
          this.generateFilter(result.eid);
        } else if (result.roleType === 'STORE_MANAGEMENT') {
          this.notClearOptions = true;

          this.filterDisable.regionName = true;
          this.filterDisable.marketId = true;
          this.filterDisable.gmEid = true;
          this.filterDisable.doEid = true;
          this.filterDisable.omEid = true;
          this.filterDisable.ocEid = true;
          this.filterDisable.storeCode = true;
          this.filterDisable.storeName = true;

          this.filter.regionName = result.regionName || '';
          this.filter.marketId = result.marketId || '';
          this.filter.gmEid = result.gmEid || '';
          this.filter.doEid = result.doEid || '';
          this.filter.omEid = result.omEid || '';
          this.filter.ocEid = result.ocEid || '';
          this.filter.storeCode = result.usCode || '';
          this.filter.storeName = result.storeName || '';

        }
      });
    },
    generateFilter(eid) {
      let eidKey = eid;
      let filterOcs = this.filterOption.ocs.filter(item => item.eid === eidKey);
      if (filterOcs && filterOcs.length > 0) {
        this.filter.omEid = filterOcs[0].parentId || '';
        this.filterDisable.omEid = true;
        eidKey = this.filter.omEid;
      }

      let filterOms = this.filterOption.oms.filter(item => item.eid === eidKey);
      if (filterOms && filterOms.length > 0) {
        this.filter.doEid = filterOms[0].parentId;
        this.filterDisable.doEid = true;
        eidKey = this.filter.doEid;
      }

      let filterDos = this.filterOption.dos.filter(item => item.eid === eidKey);
      if (filterDos && filterDos.length > 0) {
        this.filter.gmEid = filterDos[0].parentId;
        this.filterDisable.gmEid = true;
        eidKey = this.filter.gmEid;
      }

      let filterGms = this.filterOption.gms.filter(item => item.eid === eidKey);
      if (filterGms && filterGms.length > 0) {
        this.filter.marketId = filterGms[0].parentId;
        this.filterDisable.marketId = true;
        eidKey = this.filter.marketId;
      }

      let filterMarkets = this.filterOption.markets.filter(item => item.eid === eidKey);
      if (filterMarkets && filterMarkets.length > 0) {
        this.filter.regionName = filterMarkets[0].parentId;
        this.filterDisable.regionName = true;
      }
    },
    clearOptions(excluded) {
      this.gmOptions = [];
      this.doOptions = [];
      this.omOptions = [];
      this.ocOptions = [];
      this.clearFilter(excluded);
    },
    clearFilter(excludedColumn) {
      let excluded = [];
      excluded = excluded.concat(excludedColumn || []);
      excluded = excluded.concat(Object.keys(this.filterDisable));
      Object.keys(this.filter).forEach(key => {
        if (!excluded || excluded.indexOf(key) < 0) {
          this.filter[key] = '';
        }
      });
      if (!excludedColumn || excludedColumn.length < 1) {
        this.loadData(true);
      }
    },
    handleExport() {
      exportEmployeeActivityData(this.filter).then(response => {
        if (response.status === 200 && response.data && response.data.data) {
          this.exportLoading = true
          this.exportName = "导出中..."
          exporting(response.data.data, this.exportCallback)
        } else {
          this.$message({
            message: '信息导出失败',
            type: 'warning',
            showClose: true,
          });
        }
      });
    },
    handleSignUpExport() {
      exportMemberSignUpData(this.filter).then(response => {
        if (response.status === 200 && response.data && response.data.data) {
          this.exportSignUpLoading = true
          this.exportSignUpName = "导出中..."
          exporting(response.data.data, this.exportSignUpCallback)
        } else {
          this.$message({
            message: '信息导出失败',
            type: 'warning',
            showClose: true,
          });
        }
      });
    },
    exportCallback(result) {
      this.exportLoading = false
      this.exportName = "导出全表"
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
          })
      }
    },
    exportSignUpCallback(result) {
      this.exportSignUpLoading = false
      this.exportSignUpName = "导出岗位报名"
      if (result) {
        this.$message({
          showClose: true,
          message: '导出完成',
          type: 'success'
          })
      }
    },
    handleRefreshChange() {
      this.loadData();
    },
  }
}
</script>

<style lang="scss" scoped>
.activity-list-filter {
  margin: 0 10px;
  &-value {
    width: 96% !important;
  }
  &-reset {
    float: right;
    margin-right: 8px;
  }
  &-search {
    float: right;
    margin-right: 10px;
    border-color: #5383f3;
    color: #5383f3;
  }
}
</style>